import { useLocation } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';

// project imports
import config from './../../../config';
import Logo from './../../../components/common/Logo';
import { useFromQueryParam } from '../../../helpers/getFromQueryParam';
import { ROUTES } from '../../../constants';
import { useElectricPage } from '../../../helpers/isElectricPage';

//-----------------------|| MAIN LOGO ||-----------------------//

const LogoSection = ({ disabled }) => {
    const isElectricPage = useElectricPage();
    const from = useFromQueryParam();
    const isUserLoggedIn = Boolean(localStorage.getItem('token'));
    const portalUrl = process.env.REACT_APP_PORTAL_URL;
    const { pathname } = useLocation();
    const location = useLocation();
    const fromElectricHeader = location.state?.fromElectricHeader;
    const isOnContractBase = pathname === ROUTES.CONTRACT.BASE;

    const linkPath = (() => {
        if (isElectricPage || fromElectricHeader) return ROUTES.ELECTRIC.BASE;
        if (from === 'cis') return portalUrl;
        if (isUserLoggedIn) return ROUTES.CONTRACT.BASE;
        return config.defaultPath;
    })();

    const isDisabled = disabled || (isOnContractBase && isUserLoggedIn);

    return (
        <ButtonBase disableRipple component="a" href={linkPath} disabled={isDisabled}>
            <Logo />
        </ButtonBase>
    );
};

export default LogoSection;
